import { render } from "./ProductCollectionsComponent.vue?vue&type=template&id=50cf0da8"
import script from "./ProductCollectionsComponent.vue?vue&type=script&lang=js"
export * from "./ProductCollectionsComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"platform/themes/staderecord/assets/js/components/ProductCollectionsComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "50cf0da8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('50cf0da8', __exports__)) {
    api.reload('50cf0da8', __exports__)
  }
  
  module.hot.accept("./ProductCollectionsComponent.vue?vue&type=template&id=50cf0da8", () => {
    api.rerender('50cf0da8', render)
  })

}


export default __exports__